import { FacilityGroupTableElementProps } from "../../../../FacilityGroup/entities";

const style = "sticky z-[99] top-12 text-xs text-gray-700 uppercase dark:bg-gray-700 dark:text-gray-400"
export const _styledTHead: React.FC<FacilityGroupTableElementProps> = ({ children }) => {
    return (
        <thead className={style}>
            {children}
        </thead>
    )
};